import Marquee from "react-fast-marquee";

const EditorialMarquee = ({ items, className = "" }) => (
    <div className={`border-y border-line py-6 md:py-10 overflow-hidden ${className}`} data-testid="editorial-marquee">
        <Marquee speed={35} gradient={false} pauseOnHover>
            {items.map((item, i) => (
                <span key={i} className="flex items-center">
                    <span className="font-heading font-black uppercase tracking-tight text-5xl md:text-7xl lg:text-8xl text-outline px-6 md:px-10 whitespace-nowrap">
                        {item}
                    </span>
                    <span className="w-3 h-3 md:w-4 md:h-4 bg-[#FF5C00] shrink-0" />
                </span>
            ))}
        </Marquee>
    </div>
);

export default EditorialMarquee;
